// import React, { useState } from "react";

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   return (
//     <header>
//       <div className="top-bar">
//         <div className="contact-left">
//           <i className="fas fa-phone-alt"></i> +919356411908 / +918600135991
//         </div>
//         <div className="contact-right">
//           <i className="fas fa-envelope"></i> booking@etravo.in
//         </div>
//       </div>

//       <div className="main-nav">
//         <div className="logo">
//           <img src="/logo.png" alt="eTravo" />
//           {/* <span className="logo-text">e<span style={{ color: "#000" }}>Travo</span></span> */}
//         </div>

//         <button className="menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
//           <i className="fas fa-bars"></i>
//         </button>

//         <nav className={`nav-links ${isMenuOpen ? "open" : ""}`}>
//           <a href="/">HOME</a>
//           <a href="/about-us">ABOUT US</a>
//           <a href="#">FLEETS</a>
//           <a href="#">PACKAGES</a>
//           <a href="#">NETWORK</a>
//           <a href="#">SERVICES</a>
//           <a href="#">PAY ONLINE</a>
//           <a href="#">APARTEMENT</a>
//           <a href="#">CONTACT</a>
//         </nav>
//       </div>
//     </header>
//   );
// };

// export default Header;

import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';


const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSearchOpen] = useState(false);


  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };


  return (
    // <header className={`header ${scrolling ? 'sticky-header' : ''}`}>
    <header className>
      {/* Header Top */}
      <div className="header-top darkcoloor">
        <div className="container">
          <div className="row justify-content-center justify-content-xl-between align-items-center">
            <div className="col-auto">
              <div className="header-top-contact">
                <ul className='anchor d-md-flex'>
                  <li className='px-md-5 fw-bold'>
                    <a className='text-white' href="tel:+919356411908 fw-bold">
                      <i className="fas fa-phone-volume  darkcolorrr text-white"></i> +91 9356411908
                    </a>
                  </li>
                  <li className='px-md-5 fw-bold'>
                    <a className='text-white' href="tel:+918600135991 ">
                      <i className="fas fa-phone-volume  darkcolorrr text-white"></i> +91 8600135991
                    </a>
                  </li>
                  <li>
                    <a className='text-white' href="mailto:booking@etravo.in">
                      <i className="far fa-envelope darkcolorrr text-white"></i>
                      <span className='text-white fw-bold'> booking@etravo.in</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="main-navigation">
        <Navbar expand="lg">
          <Container>
            <img src="/images/logo.jpg" className='logoo' alt="logo" />
            <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
              <i className="fas fa-bars darkcolor"></i> {/* Mobile Menu Icon */}
            </Navbar.Toggle>

            <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
              <Nav className="mx-auto">
                <Nav.Link href="/" className='fw-bold nav-item'>Home</Nav.Link>
                <NavDropdown title="About Us" id="about-us-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/about" className='fw-bold nav-item'>About Us</NavDropdown.Item>
                  <NavDropdown.Item href="/testimonials" className='fw-bold nav-item'>Testimonials</NavDropdown.Item>
                  {/* <NavDropdown.Item href="/term-condition" className='fw-bold nav-item'>Term & Condition</NavDropdown.Item> */}
                  {/* <NavDropdown.Item href="/privacy-policy" className='fw-bold '>Privacy Policy</NavDropdown.Item> */}
                  <NavDropdown.Item href="/Faqs" className='fw-bold '>Faqs </NavDropdown.Item>
                 
                </NavDropdown>
                <Nav.Link href="/Network" className='fw-bold nav-item'>Our Network</Nav.Link>
                {/* <Nav.Link href="/Booking" className='fw-bold nav-item'>Booking</Nav.Link> */}
                <Nav.Link href="/Services" className='fw-bold nav-item'>Services</Nav.Link>

{/* 
              <NavDropdown title="Services" id="contact-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/Corporate-Bus-Services-Pune" className='fw-bold nav-item'> Corporate Bus Services Pune</NavDropdown.Item>
                  <NavDropdown.Item href="/Corporate-Cab-and-Bus-Services-in-Nashik" className='fw-bold nav-item'> Corporate Cab and Bus Services in Nashik</NavDropdown.Item>
                  <NavDropdown.Item href="/One-Way-Cab-Services-Mumbai-to-Pune-Drop" className='fw-bold nav-item'>  One Way Cab Services Mumbai to Pune Drop</NavDropdown.Item>
                </NavDropdown> */}
                

                <Nav.Link href="/our-fleet" className='fw-bold nav-item'>Our Fleet</Nav.Link>
                {/* <Nav.Link href="/packages" className='fw-bold nav-item'>Packages</Nav.Link> */}
                <Nav.Link href="https://pages.razorpay.com/pl_LDAHcx6Nc3XdoN/view" className='fw-bold nav-item'> Pay Online </Nav.Link>
                <Nav.Link href="/Apartment" className='fw-bold nav-item'>Apartment</Nav.Link>
                <Nav.Link href="/contact-us" className='fw-bold nav-item'>Contact Us</Nav.Link>

           
              </Nav>
              {/* <Buttonn/> */}
            </Navbar.Collapse>
            
          </Container>
         
        </Navbar>
      </div>

      {/* Search Area */}
      {isSearchOpen && (
        <div className="search-area">
          <form action="#">
            <div className="form-group">
              <input type="text" className="form-control" placeholder="Type Keyword..." />
              <button type="submit" className="search-icon-btn">
                <i className="far fa-search"></i>
              </button>
            </div>
          </form>
        </div>
      )}
    </header>
  );
};

export default Header;






